import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import moment from "moment";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Modal from 'react-bootstrap/Modal';
import { Average, Excellent, Good, Happy, Poor } from "../UserControls/Icons";
import SupportTopMenu from "./SupportTopMenu";
import SupportFileAttachment from "./SupportFileAttachment";
import SupportAttachmentViewer, {
    SupportAttachmentActions,
    hasSupportAttachment,
} from "./SupportAttachmentViewer";

const FEEDBACK_OPTIONS = [
    { value: "Poor", id: "FeedBackPoor", Icon: Poor },
    { value: "Average", id: "FeedBackAverage", Icon: Average },
    { value: "Good", id: "FeedBackGood", Icon: Good },
    { value: "Happy", id: "FeedBackHappy", Icon: Happy },
    { value: "Excellent", id: "FeedBackExcellent", Icon: Excellent },
];

function isSubmitterMessage(item) {
    const adminId = Number(item?.AdminID ?? item?.adminID ?? 0);
    return adminId <= 0;
}

function TicketsListing(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [replies, setReplies] = useState([]);
    const [ticket, setTicket] = useState({});
    const [assignees, setAssignees] = useState({ users: [], staff: [] });
    const [assignValue, setAssignValue] = useState("");
    const [assignLoading, setAssignLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [AttachmentString, setAttachmentString] = useState("");
    const [replySaved, setReplySaved] = useState(false);
    const params = useParams();
    const navigate = useNavigate();
    const [ClosedByAdmin, SetClosedByAdmin] = useState("");
    const [ClosedByUser, SetClosedByUser] = useState("");
    const [isSupportAdministrator, setIsSupportAdministrator] = useState(
        localStorage.getItem("User_Group_ID") === "1"
    );

    const [loadingTickets, setLoadingTickets] = useState(false);
    const [attachmentImg, setAttachmentImg] = useState(null);
    const [description, setdescription] = useState("");

    const [show, setShow] = useState(false);
    const [submittingFeedback, setSubmittingFeedback] = useState(false);
    const [rejectingClose, setRejectingClose] = useState(false);
    const [showModalAttachment, setShowModalAttachment] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setfeedback("");
        setcomment("");
        setShow(true);
    };

    const handleShowModalAttachment = (item) => {
        setAttachmentImg(item);
        setShowModalAttachment(true);
    };

    const handleCloseModalAttachment = () => {
        setShowModalAttachment(false);
    };

    useEffect(() => {
        setReplySaved(false);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            ID: params.id

        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Support/GetTicketByIDAdmin',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code != 1) {
                    toast.error(response.data.status_message || "You cannot access this ticket.");
                    navigate("/support/open");
                    return;
                }
                setReplies(
                    response.data.ListofReplies ||
                    response.data.listofReplies ||
                    []
                );
                setTicket(response.data);
                if (response.data.IsSupportAdministrator !== undefined) {
                    setIsSupportAdministrator(!!response.data.IsSupportAdministrator);
                }
                if (response.data.AssignToID && response.data.AssignedToType) {
                    setAssignValue(
                        response.data.AssignedToType + ":" + response.data.AssignToID
                    );
                }
                SetClosedByAdmin(response.data.ClosedByAdmin);
                SetClosedByUser(response.data.ClosedByUser);
                const element = document.getElementById("chat-thread");
                if (element) {
                    element.scrollTop = element.scrollHeight;
                }
            })
            .catch(function () {
                toast.error("Unable to load ticket.");
                navigate("/support/open");
            });

    }, [replySaved, params.id, AccessKey, UserID, navigate]);

    useEffect(() => {
        if (!isSupportAdministrator) {
            return;
        }

        axios({
            method: "post",
            url: config.base_url + "Support/GetSupportAssignees",
            headers: { "Content-Type": "application/json" },
            data: { AccessKey, UserID, SchoolID: 1 },
        })
            .then((res) => {
                if (res.data.status_code === 1) {
                    setAssignees({
                        users: res.data.ListofUsers || [],
                        staff: res.data.ListofStaff || [],
                    });
                }
            })
            .catch(() => { });
    }, [AccessKey, UserID, isSupportAdministrator]);

    const handleAssignTicket = () => {
        if (!assignValue) return;
        const parts = assignValue.split(":");
        if (parts.length !== 2) return;
        setAssignLoading(true);
        axios({
            method: "post",
            url: config.base_url + "Support/AssignSupportTicket",
            headers: { "Content-Type": "application/json" },
            data: {
                UserID,
                AccessKey,
                ID: params.id,
                AssignedToType: parts[0],
                AssignToID: parseInt(parts[1], 10),
            },
        })
            .then((res) => {
                if (res.data.status_code === 1) {
                    toast.success(res.data.status_message);
                    setTicket((t) => ({
                        ...t,
                        AssignedToName: res.data.AssignedToName,
                        AssignToID: res.data.AssignToID,
                        AssignedToType: res.data.AssignedToType,
                    }));
                } else {
                    toast.error(res.data.status_message || "Could not assign ticket.");
                }
                setAssignLoading(false);
            })
            .catch(() => {
                setAssignLoading(false);
                toast.error("Network error.");
            });
    };

    const SubmitReply = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            setLoadingTickets(true);
            const data = {
                UserID: UserID,
                AccessKey: AccessKey,
                ID: params.id,
                Description: description,
                Status: "",
                FileAttached: AttachmentString,
            };

            var api_config = {
                method: 'post',
                url: config.base_url + 'Support/AdminReplyTicket',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(api_config)
                .then(function (response) {
                    //console.log(response.data);
                    if (response.data.status_code == 1) {
                        setReplySaved(true);
                        setdescription("");
                        setAttachmentString("");
                        //console.log(response.data)
                        // status.current.value = null;
                        setValidated(false);
                        setLoadingTickets(false);
                        const chatThread = document.getElementById("chat-thread");
                        if (chatThread) {
                            chatThread.scrollTop = chatThread.scrollHeight;
                        }
                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setLoadingTickets(false);
                    }


                })
                .catch(function () {
                    setLoadingTickets(false);
                    toast.error('Network Error..', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });
            setValidated(true);
        }
    };
    const renderReplies = () => {
        if (!replies) return null;

        return replies.map((item, index) => {
            const isUser = isSubmitterMessage(item);

            const fullName = isUser
                ? item.Member_Name || ticket.FullName || "User"
                : item.Admin_Name || "Support";

            const firstLetter = fullName?.charAt(0)?.toUpperCase();

            return (
                <li
                    key={item.ID || index}
                    className={`chat-item ${isUser ? "student" : "admin"}`}
                >
                    {/* AVATAR */}
                    <div
                        className={`chat-avatar ${isUser ? "student-avatar" : "admin-avatar"
                            }`}
                        title={fullName}
                    >
                        {firstLetter}
                    </div>

                    {/* MESSAGE */}
                    <div className="chat-text">
                        <div
                            className={`message-bubble ${isUser ? "student-bubble" : "admin-bubble"
                                }`}
                        >
                            <div
                                className="message-content"
                                dangerouslySetInnerHTML={{
                                    __html: item.Description,
                                }}
                            />

                            <span className="bubble-date">
                                {moment(item.Created_Date).format(
                                    "DD MMM YYYY • hh:mm A"
                                )}
                            </span>
                        </div>

                        {/* ATTACHMENT */}
                        {hasSupportAttachment(item) && (
                            <SupportAttachmentActions
                                source={item}
                                onView={handleShowModalAttachment}
                            />
                        )}
                    </div>
                </li>
            );
        });
    };

    const [feedback, setfeedback] = useState("");
    const [comment, setcomment] = useState("");

    const adminClosed = ClosedByAdmin === true;
    const userClosed = ClosedByUser === true;
    const ticketIsClosed =
        ticket.Status === "Closed" || (adminClosed && userClosed);
    const pendingUserClose = userClosed && !adminClosed;
    const pendingAdminResolve = adminClosed && !userClosed;
    const ticketIsOpen = !adminClosed && !userClosed;

    const handleFeedBack = (event) => {
        if (event.target.checked) {
            setfeedback(event.target.value);
        }
    };

    const sendfeedback = () => {
        if (!feedback) {
            toast.error("Please select a rating.");
            return;
        }

        setSubmittingFeedback(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            ID: params.id,
            Feedback: feedback,
            Comments: comment,
        };

        axios({
            method: "post",
            url: config.base_url + "Support/CloseTicketAdmin",
            headers: { "Content-Type": "application/json" },
            data: data,
        })
            .then(function (response) {
                if (response.data.status_code === 1) {
                    setShow(false);
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setReplySaved(true);
                } else {
                    toast.error(
                        response.data.status_message || "Could not close ticket.",
                        { position: toast.POSITION.TOP_RIGHT }
                    );
                }
            })
            .catch(function () {
                toast.error("Network error.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            })
            .finally(function () {
                setSubmittingFeedback(false);
            });
    };

    const TicketNotClosed = () => {
        setRejectingClose(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            ID: params.id,
        };

        axios({
            method: "post",
            url: config.base_url + "Support/TicketNotClosed",
            headers: { "Content-Type": "application/json" },
            data: data,
        })
            .then(function (response) {
                if (response.data.status_code === 1) {
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setReplySaved(true);
                } else {
                    toast.error(
                        response.data.status_message || "Could not update ticket.",
                        { position: toast.POSITION.TOP_RIGHT }
                    );
                }
            })
            .catch(function () {
                toast.error("Network error.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            })
            .finally(function () {
                setRejectingClose(false);
            });
    };

    const rendercloseadmin = () => {
        if (ticketIsClosed) {
            return null;
        }

        if (pendingUserClose) {
            return (
                <li className="col-12 list-unstyled w-100">
                    <div className="sms-recode mb-3">
                        <p>The user requested to close this ticket. Confirm?</p>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mb-3">
                        <button type="button" className="button button-primary" onClick={handleShow}>
                            <span><i className="ri-checkbox-circle-line"></i> Yes, close</span>
                        </button>
                        <button
                            type="button"
                            className="button button-primary"
                            disabled={rejectingClose}
                            onClick={TicketNotClosed}
                        >
                            <span><i className="ri-close-circle-line"></i> No, keep open</span>
                        </button>
                    </div>
                </li>
            );
        }

        if (pendingAdminResolve) {
            return (
                <li className="col-12 list-unstyled w-100">
                    <div className="sms-recode mb-3">
                        <p>You asked the user if their issue is resolved. Close this ticket now?</p>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mb-3">
                        <button type="button" className="button button-primary" onClick={handleShow}>
                            <span><i className="ri-checkbox-circle-line"></i> Yes, close</span>
                        </button>
                        <button
                            type="button"
                            className="button button-primary"
                            disabled={rejectingClose}
                            onClick={TicketNotClosed}
                        >
                            <span><i className="ri-close-circle-line"></i> No, still open</span>
                        </button>
                    </div>
                </li>
            );
        }

        return null;
    };

    const renderreply = () => {
        const canReply =
            !ticketIsClosed &&
            !pendingAdminResolve &&
            (pendingUserClose || ticketIsOpen);

        if (!canReply) return null;

        return (
            <div className="reply-box">
                <SupportFileAttachment
                    compact
                    value={AttachmentString}
                    onChange={setAttachmentString}
                    inputId="AdminReplyAttach"
                    disabled={loadingTickets}
                />
                <textarea
                    rows={1}
                    value={description}
                    className="send-reply"
                    onChange={(e) => setdescription(e.target.value)}
                    placeholder="Type your reply..."
                />

                <button
                    type="submit"
                    disabled={loadingTickets || !description.trim()}
                    className="reply-button"
                >
                    Send
                    <i className="ri-send-plane-2-fill"></i>
                </button>
            </div>
        );
    };
    const renderCloseButton = () => {
        if (ticketIsClosed || pendingUserClose || pendingAdminResolve) {
            return null;
        }

        if (ticketIsOpen) {
            return (
                <div className="my-3 text-md-start text-center">
                    <button
                        type="button"
                        onClick={handleShow}
                        className="button button-primary"
                    >
                        Close Ticket
                    </button>
                </div>
            );
        }

        return null;
    };


    return (
        <>
            <ToastContainer />
            <Modal className="modal-theme modal-small p-0" show={show} onHide={handleClose}>
                <div className="modal-header">
                    <div className="modal-title h2">Feedback</div>

                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
                </div>
                <Modal.Body>
                    <p className="small text-muted mb-3">Rate your support experience before closing this ticket.</p>
                    <ul className="feedback_list">
                        {FEEDBACK_OPTIONS.map(({ value, id, Icon }) => (
                            <li key={value}>
                                <label
                                    htmlFor={id}
                                    className={feedback === value ? "active" : ""}
                                >
                                    <Icon />
                                    <span>{value}</span>
                                    <input
                                        id={id}
                                        name="ticketFeedback"
                                        type="radio"
                                        value={value}
                                        onChange={handleFeedBack}
                                        checked={feedback === value}
                                    />
                                </label>
                            </li>
                        ))}
                        <li>
                            <div className="form_default w-100">
                                <div className="form-group">
                                    <div className="inputwrap">
                                        <textarea
                                            rows={3}
                                            style={{ boxShadow: "none" }}
                                            onChange={(e) => setcomment(e.target.value)}
                                            className="form-control"
                                            placeholder="Comments (optional)"
                                            value={comment}
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <button
                                type="button"
                                onClick={sendfeedback}
                                disabled={!feedback || submittingFeedback}
                                className="button button-primary w-100"
                            >
                                <span>{submittingFeedback ? "Closing..." : "Submit & Close Ticket"}</span>
                            </button>
                        </li>
                    </ul>
                </Modal.Body>
            </Modal>
            <SupportAttachmentViewer
                show={showModalAttachment}
                fileName={attachmentImg}
                onHide={handleCloseModalAttachment}
            />
            <SupportTopMenu />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/support/raise-ticket">Support</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Tickets Details</li>
                                </ol>
                            </nav>
                            <div className="page-title">Tickets Details ({ticket.TicketType})</div>
                            {ticket.FullName ? (
                                <p className="small text-muted mb-0">
                                    From: {ticket.FullName}
                                    {ticket.MemberType ? ` (${ticket.MemberType})` : ""}
                                    {ticket.ContactNo ? ` · ${ticket.ContactNo}` : ""}
                                </p>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            {isSupportAdministrator ? (
                            <div className="d-flex flex-wrap gap-2 align-items-end justify-content-md-end">
                                <div>
                                    <label className="form-label small mb-1">Assigned to</label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={assignValue}
                                        onChange={(e) => setAssignValue(e.target.value)}
                                        style={{ minWidth: "220px" }}
                                    >
                                        <option value="">
                                            {ticket.AssignedToName || "Select assignee"}
                                        </option>
                                        <optgroup label="Users">
                                            {assignees.users.map((u) => (
                                                <option key={`U-${u.AssignToID}`} value={`User:${u.AssignToID}`}>
                                                    {u.DisplayName}
                                                </option>
                                            ))}
                                        </optgroup>
                                        <optgroup label="Staff">
                                            {assignees.staff.map((s) => (
                                                <option key={`S-${s.AssignToID}`} value={`Staff:${s.AssignToID}`}>
                                                    {s.DisplayName}
                                                </option>
                                            ))}
                                        </optgroup>
                                    </select>
                                </div>
                                <button
                                    type="button"
                                    className="button button-primary"
                                    disabled={assignLoading || !assignValue}
                                    onClick={handleAssignTicket}
                                >
                                    {assignLoading ? "Assigning..." : "Assign"}
                                </button>
                            </div>
                            ) : ticket.AssignedToName ? (
                                <p className="text-md-end small text-muted mb-0">
                                    Assigned to: <strong>{ticket.AssignedToName}</strong>
                                </p>
                            ) : null}
                        </div>

                    </div>
                </div>
            </div>
            <div className="container">
                <div className="ticket-card card mb-3">
                    <div className="card-body ticket-card-body">

                        {/* TOP INFO ROW */}
                        <div className="ticket-meta">
                            <div className="meta-item">
                                <i className="ri-coupon-line"></i>
                                <span>Ticket #{ticket.TicketID}</span>
                            </div>

                            <div className="meta-item">
                                <i className="ri-calendar-2-fill"></i>
                                <span>
                                    {ticket.Dated
                                        ? moment(ticket.Dated).format("DD MMM YYYY • hh:mm A")
                                        : "-"}
                                </span>
                            </div>

                            <div className="meta-item">
                                <i className="ri-chat-poll-line"></i>
                                <span>{ticket.NoofReplies} messages</span>
                            </div>

                            <div className={`ticket-status ${ticket.Status?.toLowerCase()}`}>
                                {ticket.Status}
                            </div>
                            {ticket.AssignedToName ? (
                                <div className="ticket-status open"><i className="ri-user-line"></i> {ticket.AssignedToName}</div>
                            ) : null}
                        </div>

                        {/* SUBJECT */}
                        {ticket.Subject && (
                            <div className="ticket-subject">
                                {ticket.Subject}
                            </div>
                        )}

                        {/* ATTACHMENT */}
                        {hasSupportAttachment(ticket) && (
                            <SupportAttachmentActions
                                source={ticket}
                                onView={handleShowModalAttachment}
                                label="View original attachment"
                            />
                        )}

                    </div>
                </div>
                <div className="message-wrap support-ticket-thread">
                    <div id="chat-thread" className="chat-thread">
                        <ul className="chat-list">
                            {renderReplies()}
                            {rendercloseadmin()}
                        </ul>
                    </div>
                    <Form noValidate validated={validated} onSubmit={SubmitReply}>
                        {renderreply()}
                    </Form>
                </div>
                {renderCloseButton()}
            </div>
        </>
    );
}

export default TicketsListing;